import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { adminMe } from '@/lib/api';

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState('checking');
  useEffect(() => {
    if (!localStorage.getItem('alofisa_token')) {
      setState('redirect');
      return;
    }
    adminMe()
      .then(() => setState('ok'))
      .catch(() => {
        localStorage.removeItem('alofisa_token');
        setState('redirect');
      });
  }, []);
  if (state === 'checking') return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Vérification…</div>;
  if (state === 'redirect') return <Navigate to="/admin/login" replace />;
  return children;
}
